import {css} from '@sail/engine/deprecated';
import {DefaultTheme, Theme} from './theme';

// consistent with stripe.com
export const dotComTransitions = {
  buttonTransition: '150ms cubic-bezier(0.215,0.61,0.355,1)',
};

export const dotComColors = {
  brand: '#FFFFFF',
  brand300: '#E7ECF1',
  brand400: '#ABB5C5',
  brand500: '#0A2540',
  brand600: '#3F4B66',
  brand700: '#F6F9FB',
  brand800: '#727F96',
  brand900: '#21252C',
  brandButton: '#635BFF',
  focusOutline: '#4d90fe',
  inputTextDisabled: '#C4CCD8',
  iconDisabled: '#E7ECF1',
};

export const DotComTheme: Theme = {
  ...DefaultTheme,
  brandColor: dotComColors.brand,
  onBrandTextColor: dotComColors.brand900,
  ctaHoverColor: dotComColors.brand,
  linkColor: dotComColors.brandButton,
  focusVisibleOutline: css.value(`2px solid ${dotComColors.focusOutline}`),
  headerBarGradient:
    'linear-gradient(to right, #02BCF5, #635BFF 31%, #9966FF 58%, #8D90F4)',
  audience: 'dot_com',
};

export const DotComThemeChroma: Theme = {
  ...DotComTheme,
  linkColor: '#635bff',
  headerBarGradient:
    'linear-gradient(to right, #02BCF5, #635BFF 31%, #9966FF 58%, #8D90F4)',
};

export const DotComThemeCottonCandy: Theme = {
  ...DotComTheme,
  linkColor: '#0073e6',
  headerBarGradient:
    'linear-gradient(to right, #9966ff, #0073e6 31%, #4536ff 58%, #0073e6)',
};

export const DotComThemeLemonLime: Theme = {
  ...DotComTheme,
  linkColor: '#15be53',
  headerBarGradient:
    'linear-gradient(to right, #ffa833, #15be53 31%, #00d924 58%, #15be53)',
};

export const DotComThemeOvercast: Theme = {
  ...DotComTheme,
  linkColor: '#0073e6',
  headerBarGradient:
    'linear-gradient(to right, #08a7e0, #0073e6 31%, #066fce 58%, #1946b9)',
};

export const DotComThemePomegranate: Theme = {
  ...DotComTheme,
  linkColor: '#9966ff',
  headerBarGradient:
    'linear-gradient(to right, #ff96b9, #9966ff 31%, #9966ff 58%, #ffad3f)',
};

export const DotComThemeSlate: Theme = {
  ...DotComTheme,
  linkColor: '#657d92',
  headerBarGradient:
    'linear-gradient(to right, #A54DDD, #635BFF 31%, #9966FF 58%, #8D90F4)',
};

export const DotComThemeSunburst: Theme = {
  ...DotComTheme,
  linkColor: '#ff7600',
  headerBarGradient:
    'linear-gradient(to right, #ffd848, #ff7600 31%, #ffbb00 58%, #ff7600)',
};

export const DotComThemeTropical: Theme = {
  ...DotComTheme,
  linkColor: '#02bcf5',
  headerBarGradient:
    'linear-gradient(to right, #98bdeb , #02bcf5 31%, #efa5f8 58%, #02bcf5)',
};

export const DotComThemeTwilight: Theme = {
  ...DotComTheme,
  linkColor: '#9966ff',
  headerBarGradient:
    'linear-gradient(to right, #11efe3, #9966ff 31%, #4744ff 58%, #45dfff)',
};

export const DotComThemeWintergreen: Theme = {
  ...DotComTheme,
  linkColor: '#15be53',
  headerBarGradient:
    'linear-gradient(to right, #11efe3, #15be53 31%, #1dcb63 58%, #15be53)',
};
